import { delayRetrieveRecords, retrieveRecords } from './search';

export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export function clearFilters() {
  return (dispatch) => {
    dispatch({ type: CLEAR_FILTERS });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_PAGE = 'CHANGE_PAGE';
export function changePage(page) {
  return (dispatch) => {
    dispatch({ page, type: CHANGE_PAGE });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_SEARCH_TEXT = 'CHANGE_SEARCH_TEXT';
export function changeSearchText(value) {
  return (dispatch) => {
    dispatch({ value, type: CHANGE_SEARCH_TEXT });

    return dispatch(delayRetrieveRecords());
  };
}

export const CHANGE_ASSIGNMENT_TYPE_FILTER = 'CHANGE_ASSIGNMENT_TYPE_FILTER';
export function changeAssignmentTypeFilter(assignmentTypeFilter) {
  return (dispatch) => {
    dispatch({ assignmentTypeFilter, type: CHANGE_ASSIGNMENT_TYPE_FILTER });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_BROKER_FILTER = 'CHANGE_BROKER_FILTER';
export function changeBrokerFilter(brokerFilter) {
  return (dispatch) => {
    dispatch({ brokerFilter, type: CHANGE_BROKER_FILTER });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_PROPERTY_TYPE_FILTER = 'CHANGE_PROPERTY_TYPE_FILTER';
export function changePropertyTypeFilter(propertyTypeFilter) {
  return (dispatch) => {
    dispatch({ propertyTypeFilter, type: CHANGE_PROPERTY_TYPE_FILTER });

    return dispatch(retrieveRecords());
  };
}

export const CHANGE_STATUS_FILTER = 'CHANGE_STATUS_FILTER';
export function changeStatusFilter(statusFilter) {
  return (dispatch) => {
    dispatch({ statusFilter, type: CHANGE_STATUS_FILTER });

    return dispatch(retrieveRecords());
  };
}
